export default __webpack_public_path__ + "static/media/5.972affa4.jpeg";